<template>
  <!-- s::PAGE -->
  <div class="contents">
    <div v-if="isPrivacyOptional" class="policy">
      <h2>개인정보 수집 및 이용</h2>
      <div class="box">
        <PrivacyOptional/>
      </div>
    </div>
    <div v-else-if="isPrivacy" class="policy">
      <h2>개인정보 처리방침</h2>
      <PolicyVersionTabs
          v-model="privacyVersion"
          :versions="POLICY_VERSIONS"
          aria-label="개인정보 처리방침 버전"
      />
      <div class="box">
        <Privacy v-if="privacyVersion === LATEST"/>
        <PrivacyV20250611 v-else/>
      </div>
    </div>
    <div v-else-if="isTerms" class="policy">
      <h2>이용약관</h2>
      <PolicyVersionTabs
          v-model="termsVersion"
          :versions="POLICY_VERSIONS"
          aria-label="이용약관 버전"
      />
      <div class="box">
        <Terms v-if="termsVersion === LATEST"/>
        <TermsV20250611 v-else/>
      </div>
    </div>

  </div>
  <!-- e::PAGE -->
</template>

<script setup>
import { computed, ref, watch } from "vue";
import { useRoute } from "vue-router";
import Privacy from "@/components/policy/Privacy.vue";
import Terms from "@/components/policy/Terms.vue";
import PrivacyOptional from "@/components/policy/PrivacyOptional.vue";
import PolicyVersionTabs from "@/components/policy/PolicyVersionTabs.vue";
import TermsV20250611 from "@/components/policy/terms/TermsV20250611.vue";
import PrivacyV20250611 from "@/components/policy/privacy/PrivacyV20250611.vue";

const LATEST = "latest";
const PREVIOUS = "v20250611";

// 시행일 기준 버전. 이용약관·개인정보 처리방침이 같은 날짜로 개정돼 라벨을 공유한다.
const POLICY_VERSIONS = [
  { id: LATEST, label: "최신 · 2026.09.07 시행" },
  { id: PREVIOUS, label: "이전 · 2025.06.11 시행" },
];

const route = useRoute();
const isPrivacyOptional = computed(() => route.path.includes("privacy-optional"));
const isPrivacy = computed(() => route.path.includes("privacy"));
const isTerms = computed(() => route.path.includes("terms"));

// URL 은 /terms · /privacy 로 고정이고 버전은 로컬 state 로만 전환한다 (Seven 확정, mimio#46).
// → 라우터를 건드리지 않으므로 주소·뒤로가기 히스토리가 변하지 않고, 새로고침하면 최신으로 돌아온다.
const termsVersion = ref(LATEST);
const privacyVersion = ref(LATEST);

watch(() => route.path, () => {
  termsVersion.value = LATEST;
  privacyVersion.value = LATEST;
});
</script>
